export default __webpack_public_path__ + "static/media/invite-carousel-solid.05be4f9d.png";